import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/components/Footer/scrollToTop.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[lng]/components/RootLayoutClient.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/public/facebook.png");
;
import(/* webpackMode: "eager" */ "/app/public/icons/support.png");
;
import(/* webpackMode: "eager" */ "/app/public/tg.png");
;
import(/* webpackMode: "eager" */ "/app/public/youtube.png");
;
import(/* webpackMode: "eager" */ "/app/styles/global.css");
